import React from "react";
import FormHelperText from "@material-ui/core/FormHelperText";
import { makeStyles } from "@material-ui/styles";
const useStyles = makeStyles(({
  palette,
  typography
}) => ({
  text: {
    textTransform: "uppercase",
    color: palette.text.primary,
    fontSize: typography.pxToRem(11),
    opacity: 0.4,
    letterSpacing: 0.2,
    position: "absolute",
    bottom: typography.pxToRem(-4),
    transform: "translateY(100%)",
    whiteSpace: "nowrap"
  }
}));

const InputErrorMessage = ({
  message
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(FormHelperText, {
    className: styles.text
  }, message);
};

export default InputErrorMessage;